export default "__VITE_PUBLIC_ASSET__be083cf2__"